/* 游民落地页「One Mini PC」的三行折叠面板。
 *
 * 交互是滚动叙事：本节被钉住（见 CSS 里 .modes-pin > .modes 的 sticky），滚动位置决定
 * 展开哪一行——刚进本节时第 1 行是开的，再往下滚一段换成第 2 行，再滚一段换成第 3 行，
 * 三行都过完本节才被放走，后面的块才进得来。读的是真实滚动位置，所以右侧滚动条直接拖、
 * 键盘翻页、手机惯性滚动都一样管用，不劫持滚轮。
 *
 * 钉住靠高度：脚本把外层 .modes-pin 撑成「本节高 + (行数-1) 个步长」，本节在里头 sticky。
 * 高度只由脚本加——禁用 JS 时容器高度等于内容，本节就是个静态折叠面板（默认展开第 1 行）。
 *
 * 行头仍是 button，点了滚到那一行对应的滚动位置，而不是直接切展开态：滚动位置是唯一的
 * 事实来源，点击与滚动两条输入才不会互相打架，键盘与读屏也照旧能用。
 *
 * 展开态只切 is-open 类名与 aria-expanded，高度怎么变全在 CSS。
 */
(function () {
  'use strict';

  var SECTIONS_PER_FRAME = 1;   // 每翻一行要滚几个「本节高」——想改手感就改这一个数
  var MOTION = '(prefers-reduced-motion: reduce)';

  function init(root) {
    /* 容器在 Liquid 里，脚本是单独的 asset：两边版本可能对不上（资源被缓存住），
       容器找不到就静默退出，本节退回静态折叠面板，别炸掉整页脚本。 */
    var pin = root.parentNode;
    if (!pin || !pin.hasAttribute || !pin.hasAttribute('data-starole-nomad-modes-pin')) return;

    var items = root.querySelectorAll('[data-starole-nomad-modes-item]');
    if (items.length < 2) return;

    var current = -1;   // 只在 show() 里改；初值 -1 保证第一次 show() 一定落一帧
    var stickTop = 0;   // 本节 sticky 后停在视口哪条线上，写进 style.top
    var step = 1;       // 相邻两行之间的滚动距离
    var range = 1;      // 进度 0→1 的滚动距离 = (行数-1) × step
    var applied = pin.offsetHeight;   // 已经写进 pin.style.height 的值，用来算高度增量

    /* header 是 sticky 的（sections/header-group.json 里 sticky_header: true，样式在
       section-header.css），钉在视口顶上会被它盖住。量它下沿，贴到它下面去；不是 sticky
       就返回 0，当没有。 */
    function headerOffset() {
      var header = document.querySelector('.site-header--sticky');
      return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    }

    /* 本节高在三种展开态下是同一个值（开着的那行由 367 的面板撑着，收起的两行都是 94，
       行头 83.8 顶不到 94），所以不必每帧重量——何况过渡中途量到的是个中间值，那反而
       会让页面抖。只在进场、缩放、以及 load 之后各量一次。 */
    function layout() {
      var viewport = window.innerHeight;
      var section = root.offsetHeight;

      /* 视口放得下就整个露在 header 下面（贴 header 下沿）；放不下就退成底对齐——本节
         1080 在 1920×1080 上正好等于一屏，这时顶部 89.2 的 padding 缩到 header 底下，
         标题墨迹（本节坐标 89.2 起）正好落在 header 下沿外侧。 */
      stickTop = Math.min(headerOffset(), viewport - section);
      /* 步长跟着本节高走而不是视口高：整节是按 1rem=10px 与 vw 缩放写的，窄屏上本节
         会缩到两百来 px，用视口做步长就成了「一大片空白配一小块内容」。1920×1080 下
         本节高 1080，两者本来就相等。 */
      step = Math.max(1, Math.round(section * SECTIONS_PER_FRAME));
      range = (items.length - 1) * step;

      var height = section + range;
      var grew = height - applied;

      /* 容器长高会把本节之后的内容整体顶下去：已经滚过本节的人（刷新时停在页尾那种）
         按增量补回同样的距离，看到的画面才不动。人停在本节钉住的那段行程里时不补。 */
      if (applied > 0 && grew !== 0) {
        var pinTop = pin.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > pinTop + applied) window.scrollBy(0, grew);
      }
      applied = height;

      root.style.top = stickTop + 'px';
      pin.style.height = height + 'px';
    }

    function show(index) {
      if (index === current) return;
      current = index;

      for (var j = 0; j < items.length; j++) {
        var on = j === index;
        items[j].classList.toggle('is-open', on);

        var head = items[j].querySelector('[data-starole-nomad-modes-head]');
        if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
    }

    /* 进度不看「滚了多远」，看容器的顶边被滚到哪：本节开始钉住时容器顶边正好走到
       stickTop，钉住的行程就是 range，于是 stickTop - 容器顶边 直接就是已走的距离。
       这样量不必缓存基准点，上方内容（图片落位）高度变了也不用重算。 */
    function frameOf() {
      var progress = (stickTop - pin.getBoundingClientRect().top) / range;

      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      return Math.round(progress * (items.length - 1));
    }

    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        show(frameOf());
      });
    }

    var resizing = false;
    function relayout() {
      if (resizing) return;
      resizing = true;
      window.requestAnimationFrame(function () {
        resizing = false;
        layout();
        show(frameOf());
      });
    }

    function bind(item, index) {
      var head = item.querySelector('[data-starole-nomad-modes-head]');
      if (!head) return;

      head.addEventListener('click', function () {
        /* 滚动位置反推：进度 0 落在容器顶边压到 stickTop 的那一刻，往后每行加一个 step。 */
        var pinTop = pin.getBoundingClientRect().top + window.scrollY;
        var top = Math.round(pinTop - stickTop + index * step);

        if (window.matchMedia(MOTION).matches || !('scrollBehavior' in document.documentElement.style)) {
          window.scrollTo(0, top);
        } else {
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    }

    for (var i = 0; i < items.length; i++) bind(items[i], i);

    layout();
    show(frameOf());

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', relayout);
    /* 字体与图片落位后本节高度可能差几 px，重新量一次 */
    window.addEventListener('load', relayout);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-starole-nomad-modes]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
